import type { Post } from "@/types/content";

export const postsPart6: Post[] = [
  {
    id: "post-30",
    slug: "shuya-secret-spa-single-review",
    title: "舒壓秘境 SPA 單店深度評測｜台北最極致的深層油壓體驗",
    excerpt: "隱身在大安區巷弄中的舒壓秘境 SPA，沒有浮誇的裝潢，卻憑藉師傅出神入化的手技，成為許多按摩老饕的私藏名單。神秘客兩度造訪，帶你深入了解這間店的一切。",
    coverImage: "https://readdy.ai/api/search-image?query=Luxury%20private%20spa%20treatment%20room%20with%20warm%20amber%20lighting%20candles%20essential%20oils%20on%20wooden%20table%20professional%20massage%20bed%20zen%20minimalist%20interior%20simple%20clean%20background%20photography%20beauty%20wellness&width=1200&height=630&seq=5001&orientation=landscape",
    category: "按摩",
    contentType: "singleShopReview",
    tags: ["台北", "按摩", "SPA", "單店評測", "深層油壓", "大安區", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室。",
    },
    publishedAt: "2025-05-25",
    readingTime: 8,
    rating: 4.9,
    reviewCount: 85,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>舒壓秘境 SPA 位於大安區忠孝東路四段的巷弄中，門面低調到走過去可能會錯過。但推開門的那一刻，溫暖的木質香氛與柔和燈光瞬間讓人放鬆下來。這裡沒有網美打卡牆，沒有花俏的包裝，只有師傅扎實到令人驚嘆的手技。</p><p>神秘客兩度匿名造訪，一次選 60 分鐘精油按摩，一次選 90 分鐘深層油壓。以下是我們的完整體驗記錄。</p>",
      },
      {
        _type: "shopReview",
        _key: "review",
        title: "單店深度評測",
        shops: [
          {
            _key: "s1",
            name: "舒壓秘境 SPA",
            rating: 4.9,
            priceRange: "$1,200 - $3,500",
            address: "台北市大安區忠孝東路四段 123 號 2F",
            tags: ["獨立包廂", "淋浴設施", "情侶雙人房"],
            pros: ["師傅手法細膩，穴位按得很準，每一下都有感", "包廂隱私性極佳，完全不受打擾", "療程後的手工餅乾與養生茶讓人感覺被用心對待"],
            cons: ["週末較難預約，建議提前一週", "價格偏高，適合犒賞自己的時候", "門面低調，第一次來可能找不到"],
            recommendation: "適合追求高品質舒壓體驗的人，情侶一起來也很棒。強烈建議選 90 分鐘深層油壓，多出的 30 分鐘師傅會把肩頸和腰背處理得更徹底。",
            image: "https://readdy.ai/api/search-image?query=Luxury%20spa%20treatment%20room%20with%20warm%20amber%20lighting%20candles%20and%20flower%20petals%20on%20massage%20table%20zen%20minimalist%20interior%20simple%20clean%20background%20photography&width=600&height=400&seq=301&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=舒壓秘境+SPA+台北",
          },
        ],
      },
      {
        _type: "richText",
        _key: "detail",
        content: "<h3>環境與氛圍</h3><p>店內空間不大，約 6 個包廂，每間都有獨立淋浴間。裝潢以原木與米色為主，燈光偏暖黃，音樂是淡淡的環境音樂而非流行歌曲，整體氛圍讓人很快進入放鬆狀態。</p><h3>師傅手技</h3><p>兩次體驗分別由不同師傅服務，但水準都非常一致。按壓時會詢問力道是否適合，並根據你的回饋即時調整。深層油壓的力道足夠深入到筋膜層，但又不會痛到無法忍受，這個平衡點掌握得極好。</p><h3>總結</h3><p>舒壓秘境 SPA 是一間「回訪率超高」的店。雖然價格不便宜，但每一分錢都花得值得。如果你想找一間能真正讓身體得到深層修復的按摩店，這間應該在你的清單上。</p>",
      },
    ],
    seo: {
      title: "舒壓秘境 SPA 單店深度評測｜台北深層油壓體驗",
      description: "神秘客兩度匿名造訪舒壓秘境 SPA，完整評測環境、手技、服務。台北大安區最極致的深層油壓體驗。",
      keywords: ["舒壓秘境", "台北按摩", "深層油壓", "SPA評測"],
    },
  },
  {
    id: "post-31",
    slug: "nail-artist-xiaoqing-story",
    title: "從上班族到美甲創業家：小晴的 5 年蛻變之路",
    excerpt: "5 年前還在辦公室敲鍵盤的小晴，如今已是中山區頗負盛名的美甲工作室老闆。她的故事，是許多台灣美業創業者的縮影。",
    coverImage: "https://readdy.ai/api/search-image?query=Young%20asian%20taiwanese%20female%20nail%20artist%20with%20black%20hair%20working%20on%20intricate%20floral%20nail%20design%20in%20her%20cozy%20modern%20nail%20studio%20warm%20natural%20lighting%20from%20window%20clean%20white%20interior%20with%20colorful%20nail%20polish%20bottles%20simple%20background%20photography%20editorial%20quality&width=1200&height=630&seq=5002&orientation=landscape",
    category: "美甲",
    contentType: "story",
    tags: ["美甲", "創業故事", "人物專訪", "美甲師", "職涯", "女性創業"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。",
    },
    publishedAt: "2025-05-26",
    readingTime: 7,
    rating: 4.5,
    reviewCount: 42,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>中山區一棟老舊公寓的四樓，推開門是截然不同的小世界——三面採光的工作室裡，小晴正專注地為客人描繪手繪花卉。很難想像，5 年前的她還是個每天通勤 2 小時、坐在辦公室裡做財務報表的上班族。</p><p>「我大學學的是會計，畢業後進了一間不錯的公司，薪水穩定、同事也好相處。但每天下班後，我都會覺得這一天好像沒有真正活過。」小晴放下筆，笑著說。</p>",
      },
      {
        _type: "richText",
        _key: "turning",
        content: "<h3>轉捩點：一堂體驗課</h3><p>改變發生在一次朋友邀請的美甲體驗課。「我第一次發現，原來專注做一件精細的事可以這麼快樂。」那堂課後，小晴每個週末都會去上美甲課程，從基礎保養、單色光療，慢慢學到手繪與立體飾品。</p><p>兩年後，她存夠了第一筆創業基金，毅然辭職，在中山區租下一間 6 坪大的小工作室。</p><h3>創業初期的艱難</h3><p>「前半年幾乎沒有客人。」小晴坦承，「我每天在 IG 發作品、做免費手模累積作品集、參加市集擺攤。最慘的時候一個月收入只有 8,000 元。」但她堅持做好每一雙手，即使只是最基本的單色光療，也會花 30 分鐘做好前置保養。</p><h3>現在的工作室</h3><p>如今小晴的工作室已經擴展到 12 坪，有固定的助理，預約排程常常排到兩週後。她最驕傲的不是營業額，而是「回頭客比例超過 70%」。「客人願意再來，就是對我最大的肯定。」</p><p>談到給想進入美業的人的建議，小晴說：「技術可以學，但『想把客人做到最好』的那份心，才是能不能走下去的關鍵。」</p>",
      },
    ],
    seo: {
      title: "從上班族到美甲創業家：小晴的 5 年蛻變之路",
      description: "中山區美甲工作室老闆小晴的創業故事。從會計上班族到美甲創業家，5 年間的艱難與成長。",
      keywords: ["美甲創業", "女性創業", "美甲師", "職涯故事", "中山區美甲"],
    },
  },
  {
    id: "post-32",
    slug: "facial-first-timer-guide",
    title: "第一次做臉前要知道的 8 件事｜新手完整指南",
    excerpt: "第一次踏進美容工作室難免緊張。這篇指南幫你做好心理與實務準備，讓初體驗順利又安心，避免踩雷與被推銷。",
    coverImage: "https://readdy.ai/api/search-image?query=Young%20asian%20taiwanese%20woman%20lying%20comfortably%20on%20facial%20treatment%20bed%20in%20clean%20modern%20beauty%20clinic%20with%20professional%20skincare%20products%20nearby%20soft%20warm%20lighting%20serene%20atmosphere%20simple%20clean%20background%20photography%20editorial%20quality%20beauty%20wellness&width=1200&height=630&seq=5003&orientation=landscape",
    category: "做臉",
    contentType: "guide",
    tags: ["做臉", "皮膚管理", "新手指南", "美容", "入門", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室。",
    },
    publishedAt: "2025-05-27",
    readingTime: 6,
    rating: 4.4,
    reviewCount: 67,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>第一次做臉，腦袋裡一定有很多問號：會痛嗎？要多久？會不會被推銷？要做什麼準備？作為走訪過 60 間以上美容工作室的神秘客，這篇幫你整理好所有該知道的事。</p>",
      },
      {
        _type: "featureList",
        _key: "tips",
        title: "第一次做臉的 8 個重點",
        features: [
          { _key: "t1", icon: "ri-search-line", title: "1. 先做功課，選對店家", description: "不要隨便走進路邊發傳單的店。先看 Google 評價、IG 作品，確認是「美容工作室」而非「強迫推銷型」的店鋪。評價裡如果有很多人提到「被推銷」「一直加購」，請避開。" },
          { _key: "t2", icon: "ri-calendar-line", title: "2. 避開生理期", description: "生理期前後皮膚較敏感，容易泛紅。建議安排在生理期結束後 3-5 天，皮膚狀態最穩定。" },
          { _key: "t3", icon: "ri-drop-line", title: "3. 當天素顏前往", description: "帶妝去做臉，前置卸妝會花掉不少時間，而且部分化妝品成分可能與療程產品交互作用。素顏去最省事。" },
          { _key: "t4", icon: "ri-chat-1-line", title: "4. 誠實告知皮膚狀況", description: "過敏史、正在使用的藥物（如 A 酸）、皮膚疾病都要主動說。這不只是為了效果，更是為了安全。" },
          { _key: "t5", icon: "ri-time-line", title: "5. 預留完整時間", description: "基礎做臉通常 60-90 分鐘，如果含清粉刺可能到 120 分鐘。不要排得太趕，做臉後也需要一點時間讓皮膚鎮定。" },
          { _key: "t6", icon: "ri-shield-check-line", title: "6. 療程中感到不適要馬上說", description: "清粉刺時的痛感、導入時的刺癢感，任何不適都要即時反應。好的師傅會立即調整，不會勉強你忍受。" },
          { _key: "t7", icon: "ri-money-cny-circle-line", title: "7. 先問清楚價格與內容", description: "療程前確認價格包含哪些步驟，有沒有額外費用。如果師傅在療程中突然建議加購，你有權利說「我先不用，考慮一下」。" },
          { _key: "t8", icon: "ri-sun-line", title: "8. 做完後 3 天內加強防曬與保濕", description: "做臉後皮膚處於吸收力較好的狀態，也是較脆弱的狀態。這 3 天內避免使用刺激性產品（酸類、酒精），加強防曬與保濕。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多做臉評比",
        subtitle: "神秘客實測台北美容工作室，幫你找到最適合新手的做臉好店",
        buttonLabel: "查看做臉評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "第一次做臉前要知道的 8 件事｜新手完整指南",
      description: "第一次做臉完整攻略！事前準備、療程注意、術後保養，8 個重點幫你安心體驗不踩雷。",
      keywords: ["做臉", "第一次做臉", "做臉指南", "皮膚管理入門", "美容新手"],
    },
  },
  {
    id: "post-33",
    slug: "singing-bowl-space-single-review",
    title: "頌缽靜心療癒空間 單店深度評測｜台北最專業的聲音療癒",
    excerpt: "在中山區一棟老宅的二樓，頌缽靜心療癒空間用聲波與振動帶領來訪者進入深層放鬆。神秘客親自體驗，帶你深入了解這間台北最專業的頌缽工作室。",
    coverImage: "https://readdy.ai/api/search-image?query=Serene%20singing%20bowl%20healing%20room%20with%20nepalese%20brass%20bowls%20candles%20soft%20warm%20lighting%20meditation%20cushions%20peaceful%20zen%20atmosphere%20clean%20simple%20background%20photography%20wellness%20studio&width=1200&height=630&seq=5004&orientation=landscape",
    category: "光療舒壓",
    contentType: "singleShopReview",
    tags: ["台北", "頌缽", "聲音療癒", "單店評測", "冥想", "中山區", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。",
    },
    publishedAt: "2025-05-28",
    readingTime: 7,
    rating: 4.8,
    reviewCount: 56,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>頌缽靜心療癒空間位於中山區南京東路二段的一棟老宅二樓，沒有招牌，只有門口一盞小小的燈。推開木門，木質地板、低矮的冥想墊、以及牆角一整排的尼泊爾手工頌缽，瞬間讓都市的喧囂退到很遠的地方。</p><p>神秘客選了一個平日午後來體驗 60 分鐘的個人頌缽療癒。以下是我們的完整感受。</p>",
      },
      {
        _type: "shopReview",
        _key: "review",
        title: "單店深度評測",
        shops: [
          {
            _key: "s1",
            name: "頌缽靜心療癒空間",
            rating: 4.8,
            priceRange: "$1,200 - $3,500",
            address: "台北市中山區南京東路二段 88 號 3F",
            tags: ["頌缽", "冥想引導", "聲音療癒"],
            pros: ["引導師受過尼泊爾頌缽認證，手法專業", "空間靜謐，隔音效果極佳，完全隔絕都市噪音", "療程後提供草本茶與靜心時間，不會急著趕人"],
            cons: ["熱門時段難預約，需提前 2 週", "價格偏高，單次頌缽療癒 $2,500 起", "老宅無電梯，行動不便者需留意"],
            recommendation: "追求高品質頌缽療癒的首選。引導師的聲線與節奏掌握極佳，每次療程後都像睡了一場好覺。建議選 60 分鐘個人療癒，效果最完整。",
            image: "https://readdy.ai/api/search-image?query=Serene%20singing%20bowl%20healing%20room%20with%20nepalese%20bowls%20candles%20soft%20warm%20lighting%20meditation%20cushions%20peaceful%20zen%20atmosphere%20clean%20simple%20background%20photography%20wellness%20studio&width=600&height=400&seq=365&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=頌缽靜心療癒空間+台北+中山區",
          },
        ],
      },
      {
        _type: "richText",
        _key: "detail",
        content: "<h3>療程過程</h3><p>引導師先花 10 分鐘了解你的近期狀態與身體感受，然後請你躺在鋪設好的冥想墊上。頌缽從遠處開始敲響，聲波逐漸靠近，你能感受到振動從腳底慢慢向上蔓延。</p><p>整個過程中，引導師會適時換不同大小的缽，在不同部位上方盤旋。大缽的低頻像海浪，小缽的高頻像雨滴。40 分鐘後，我完全進入一種清醒的夢境狀態——意識還在，但身體完全放鬆，連手指都不想動。</p><h3>療程後的感覺</h3><p>結束後引導師輕聲喚醒，給了 10 分鐘的靜心時間與一杯溫熱的洋甘菊茶。走出工作室時，感覺整個人的「解析度」變低了——不再糾結於小事，整個下午都處於一種平靜而愉悅的狀態。</p><h3>總結</h3><p>如果你長期處於高壓狀態、睡眠品質不佳、或單純想要體驗一種非藥物性的深度放鬆，頌缽靜心療癒空間是我們在台北測試過的最推薦選擇。</p>",
      },
    ],
    seo: {
      title: "頌缽靜心療癒空間單店深度評測｜台北聲音療癒",
      description: "神秘客親自體驗頌缽靜心療癒空間，完整評測引導師專業度、空間品質與療癒效果。台北中山區最推薦的頌缽工作室。",
      keywords: ["頌缽療癒", "台北頌缽", "聲音療癒", "冥想推薦", "中山區療癒"],
    },
  },
  {
    id: "post-34",
    slug: "tarot-reader-aming-story",
    title: "塔羅師阿明的日常：一天解讀 20 組牌是什麼感覺",
    excerpt: "在台北大安區的一間小小塔羅工作室裡，阿明每天接待 15-20 位客人，用塔羅牌幫助他們看清眼前的路口。他的日常，遠比你想像的踏實。",
    coverImage: "https://readdy.ai/api/search-image?query=Young%20asian%20taiwanese%20male%20tarot%20reader%20with%20black%20hair%20sitting%20at%20wooden%20table%20with%20beautiful%20tarot%20cards%20spread%20out%20candles%20and%20crystals%20around%20soft%20warm%20ambient%20lighting%20intimate%20spiritual%20atmosphere%20simple%20clean%20background%20photography%20editorial%20quality&width=1200&height=630&seq=5005&orientation=landscape",
    category: "塔羅",
    contentType: "story",
    tags: ["塔羅", "人物專訪", "占卜師", "身心靈", "職涯", "大安區"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店。",
    },
    publishedAt: "2025-05-29",
    readingTime: 8,
    rating: 4.6,
    reviewCount: 38,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>阿明的工作室隱身在大安區的一棟老公寓三樓，沒有招牌，只有門上一個小小的月亮圖案。上午十點，他已經整理好了桌面——黑色絨布上整齊排著他用了十年的萊德偉特塔羅牌，旁邊是一壺剛泡好的普洱。</p><p>「我今天排了 18 組客人，週末通常會到 22 組。」阿明說話語速不快，有一種讓人靜下來的特質。很難想像，10 年前的他是一名軟體工程師。</p>",
      },
      {
        _type: "richText",
        _key: "daily",
        content: "<h3>一天的節奏</h3><p>阿明的一天從冥想 20 分鐘開始。「解讀塔羅需要很乾淨的狀態，如果我自己的情緒亂七八糟，解出來的東西也會歪。」他說。</p><p>每組客人的解讀時間約 30-45 分鐘，中間他會留 10-15 分鐘的空檔，讓自己「清空」。「上一個客人的能量會留在空間裡，如果不清理，下一個客人的解讀會受到干擾。」</p><p>中午他通常只吃簡單的輕食，「吃太飽會昏沉，解讀品質會下降。」下午繼續接待客人，傍晚六點是最後一組預約的時間。</p><h3>最常被問的問題</h3><p>「八成以上的客人問的是感情和事業。」阿明笑著說，「但最讓我印象深刻的，是一個 60 歲的阿姨來問『我這輩子還有沒有機會學畫畫』。我幫她解完牌後，她真的去報名了社區大學的繪畫課，三個月後還寄了一張她的水彩作品給我。」</p><h3>塔羅師的壓力</h3><p>一天聽這麼多人的煩惱，不會很消耗嗎？「會。所以我每週最多只接四天客人，另外三天完全休息，去爬山、看電影、或者什麼都不做。」阿明說，「如果塔羅師自己的生活過不好，怎麼幫別人指路？」</p><p>談到給想成為塔羅師的人的建議，阿明說：「先學會過好自己的人生，塔羅只是工具，不是魔法。」</p>",
      },
    ],
    seo: {
      title: "塔羅師阿明的日常：一天解讀 20 組牌的真實生活",
      description: "台北大安區塔羅師阿明的人物專訪。從軟體工程師到塔羅師，一天 20 組解讀的日常與心得。",
      keywords: ["塔羅師", "塔羅日常", "人物專訪", "占卜師", "身心靈", "大安區塔羅"],
    },
  },
  {
    id: "post-35",
    slug: "yoga-beginner-guide",
    title: "如何選擇適合自己的瑜珈課程？｜初學者完整指南",
    excerpt: "瑜珈種類百百種，初學者常常不知道從哪裡開始。這篇指南幫你搞懂各種瑜珈的差異，找到最適合自己的第一堂課。",
    coverImage: "https://readdy.ai/api/search-image?query=Bright%20modern%20yoga%20studio%20with%20wooden%20floor%20large%20windows%20natural%20sunlight%20yoga%20mats%20neatly%20arranged%20peaceful%20serene%20atmosphere%20clean%20simple%20background%20photography%20wellness%20fitness&width=1200&height=630&seq=5006&orientation=landscape",
    category: "瑜珈",
    contentType: "guide",
    tags: ["瑜珈", "皮拉提斯", "新手指南", "運動", "入門", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室。",
    },
    publishedAt: "2025-05-30",
    readingTime: 7,
    rating: 4.5,
    reviewCount: 73,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>走進瑜珈教室，看到課表上寫著「哈達瑜珈」「流瑜珈」「陰瑜珈」「熱瑜珈」「空中瑜珈」……如果你是初學者，一定會覺得頭昏。到底該選哪一種？會不會太難？會不會受傷？</p><p>這篇指南用最簡單的方式，幫你搞懂最常見的五種瑜珈類型，找到最適合你的第一堂課。</p>",
      },
      {
        _type: "featureList",
        _key: "types",
        title: "五大瑜珈類型比較",
        features: [
          { _key: "t1", icon: "ri-sun-line", title: "哈達瑜珈（Hatha）｜最適合初學者", description: "動作緩慢、每個姿勢停留時間較長，老師會詳細講解動作要點。是建立基礎與正確姿勢的最佳選擇。適合：完全沒有運動習慣、想從零開始的人" },
          { _key: "t2", icon: "ri-windy-line", title: "流瑜珈（Vinyasa）｜想流汗的人", description: "動作與呼吸連貫流動，節奏較快，會出汗。課程編排變化多，不容易無聊。適合：有一定運動基礎、喜歡動態節奏的人" },
          { _key: "t3", icon: "ri-moon-line", title: "陰瑜珈（Yin Yoga）｜壓力大想放鬆", description: "動作少、停留時間長（3-5 分鐘），主要伸展結締組織而非肌肉。過程安靜、幾乎不出汗。適合：壓力大、想放鬆、身體僵硬的人" },
          { _key: "t4", icon: "ri-fire-line", title: "熱瑜珈（Hot Yoga）｜想挑戰自己", description: "在 38-40 度的環境中練習，大量出汗，排毒效果明顯。對心肺功能要求高。適合：有運動習慣、想挑戰體能極限的人" },
          { _key: "t5", icon: "ri-drop-line", title: "空中瑜珈（Aerial Yoga）｜喜歡新鮮感", description: "利用吊床輔助完成動作，有飛翔的感覺，拍照也很好看。對核心力量有要求。適合：喜歡新鮮事物、想挑戰不同體驗的人" },
        ],
      },
      {
        _type: "featureList",
        _key: "tips",
        title: "選課前的 3 個提醒",
        features: [
          { _key: "p1", icon: "ri-user-search-line", title: "先上體驗課", description: "大部分工作室都提供單堂體驗課（$300-600），不要一次買長期方案。先確認老師的教學風格、空間品質、以及交通是否方便" },
          { _key: "p2", icon: "ri-group-line", title: "選小班制", description: "初學者建議選 8 人以下的班級，老師才有時間調整你的姿勢。大班課（15 人以上）老師根本看不到你" },
          { _key: "p3", icon: "ri-heart-pulse-line", title: "不要勉強", description: "瑜珈不是比賽，每個人的身體條件不同。感到疼痛時要停下來，用輔具或簡化版本。受傷的風險往往來自於「想跟上別人」" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多瑜珈評比",
        subtitle: "神秘客實測台北瑜珈工作室，幫你找到最適合初學者的課程",
        buttonLabel: "查看瑜珈評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "如何選擇適合自己的瑜珈課程？｜初學者完整指南",
      description: "瑜珈入門指南！哈達、流瑜珈、陰瑜珈、熱瑜珈、空中瑜珈五大類型比較，幫初學者找到最適合的第一堂課。",
      keywords: ["瑜珈入門", "瑜珈指南", "初學者瑜珈", "哈達瑜珈", "流瑜珈", "陰瑜珈"],
    },
  },
];